import { render, staticRenderFns } from "./TemplatePage.vue?vue&type=template&id=43381889&"
import script from "./TemplatePage.vue?vue&type=script&lang=js&"
export * from "./TemplatePage.vue?vue&type=script&lang=js&"
import style0 from "./TemplatePage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports